import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { PACK_HASH } from '@app-types/home-pack';

import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class GamingJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.GAMING;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_GAMING;
    protected readonly showComparatorSelection = false;
    protected readonly wordings = {
        mainTitle: 'Série Spéciale Bbox Gaming',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly tracking = {
        page: 'Eligibilite_bbox_gaming',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_Gaming',
        },
        variables: {
            type_offres: 'Offres_Gaming',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        alertTitle: 'La fibre est nécessaire pour profiter de la série spéciale Bbox Gaming',
        alertDescription: "En attendant d'être éligible, vous pouvez voir les offres disponibles chez vous.",
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Popin_adresse_non_eligible_gaming',
            nomClic: 'Ok',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_gaming',
            nomClic: 'Eligibilite_ko_gaming',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest,
    };
    protected readonly technologies = [TECHNOLOGY.FTTH];
    protected readonly showComboProductSlug = [PACK_HASH.GAMING, PACK_HASH.PS5];
    protected readonly extraCmsBlockByTab = {};
}
